import React, { useState } from 'react';
import ClapprPlayer from './ClapprPlayer';
import AzotoPlayer from './AzotoPlayer';
import { getLabel } from '../../../InitData';
import StreamingButton from './StreamingButton';

export default function PrematchHomeVideoNews(props) {
	const streamingList = props.streamingList;
	const [showedChannel, setShowedChannel] = useState(0);
	const streamObj = streamingList[showedChannel];
    
    return (
        <div id="secondo-blocco-sport" className={"sport-blocco secondo-blocco-sport tablesCompacted go-up-arrow-on-overflow"}>
            <div className="live-tv-header">
                <div className="streaming-tv-buttons-channel-container">
                    <StreamingButton obj={streamingList[0]}
                                     index={0}
                                     current={showedChannel}
                                     setChannel={setShowedChannel}
                    />
                </div>
                <div className="live-tv-title d-flex align-items-center w-100" >
                    {getLabel('prematch_page.home_video.title')}
                </div>
                {streamingList.length > 1 &&
                    <div className="streaming-tv-buttons-channel-container">
                        {streamingList.map((obj, index) => {
                            if (index > 0) {
                                return (
                                    <StreamingButton key={`button-streaming-${index}`}
                                                     obj={obj}
                                                     index={index}
                                                     current={showedChannel}
                                                     setChannel={setShowedChannel}
                                    />
                                );
                            }
                            return null;
                        })}
                    </div>
                }
            </div>
            <div id="live-tv-player-container">
                {(streamObj.pty === 'clappr' || streamObj.pty === 'silive') && 
                    <ClapprPlayer key={streamObj.pty} playerUrl={streamObj.pju} streamSource={streamObj.pssu} />    
                }
                {(streamObj.pty === 'azoto') && 
                    <AzotoPlayer key={streamObj.pty} iframeSource={streamObj.pssu} />    
                }
            </div>
            {streamObj.unws && 
                <>
                    <iframe id={'iframe-prematch-home-news'} src={streamObj.unws} />
                </>
            }
        </div>
    );
}
